/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './layout-example-copy-modal.html';
import {ALL_LAYOUTS} from '../layout-example/examples/all-layouts';
import {formatMediaTypesTranslate} from '../../common/filters/format-media-type';

export interface LayoutExampleCopySelectionResult {
  layoutExample: any;
  copyName: boolean;
  copyDescription: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-layout-example-copy-modal',
  template
})
export class LayoutExampleCopyModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  model: any;

  readonly onCopied = new Subject<LayoutExampleCopySelectionResult>();

  layoutExamples: any[] = [];
  layoutExample: any = null;
  copyName = false;
  copyDescription = false;
  originalName = '';

  constructor(
    public bsModalRef: BsModalRef,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.layoutExamples = _.map(ALL_LAYOUTS, (layoutExample: any) => _.cloneDeep(layoutExample));
  }

  copy(): void {
    if (!this.layoutExample) {
      return;
    }

    completeCopyModal(this.bsModalRef, this.onCopied, {
      layoutExample: _.cloneDeep(this.layoutExample),
      copyName: this.copyName,
      copyDescription: this.copyDescription
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  trackByLayoutExample(_index: number, layoutExample: any): any {
    return layoutExample?.id ?? layoutExample?.name ?? _index;
  }

  trackByLayoutComponent(_index: number, layoutComponent: any): any {
    return layoutComponent?.tag ?? layoutComponent?.name ?? _index;
  }

  layoutTypeText(layoutType: string): string {
    return this.translate.instant('layout.type.' + layoutType);
  }

  requiredText(required: string): string {
    return this.translate.instant('label.' + required);
  }

  choiceDisplayText(display: string): string {
    return this.translate.instant('layout.CHOICE.display.' + display);
  }

  mediaTypesText(mimeTypes: any): string {
    return formatMediaTypesTranslate(mimeTypes, (key) => this.translate.instant(key));
  }

  optionsText(layoutComponent: any): string {
    return layoutComponent?.optionsAsString || JSON.stringify(layoutComponent?.options || []);
  }
}
